import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as supplierRoutes } from './suppliers/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { routes as eventInboxRoutes } from './eventInbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import { routes as copilotRoutes } from './copilot/copilot.routes';
import { routes as onboardingRoutes } from './onboarding/onboarding.routes';
import planningRoutes from './planning/planning.routes';
import leadNetworkRoutes from './leadNetwork/leadNetwork.routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import AccessLocked from './accessLocked/Index.vue';
import NoAccounts from './noAccounts/Index.vue';
import StartPlanning from './StartPlanning.vue';


export default {
  routes: [
    {
      path: frontendURL('start/planning'),
      name: 'start_planning',
      component: StartPlanning,
    },
    {
      path: frontendURL('profile'),
      name: 'profile_redirect',
      component: AppContainer,
    },
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...copilotRoutes,
        ...onboardingRoutes,
        ...captainRoutes,
        ...eventInboxRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...companyRoutes,
        ...supplierRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        planningRoutes,
        ...leadNetworkRoutes.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('accounts/:accountId/access-locked'),
      name: 'account_access_locked',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: AccessLocked,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },

  ],
};
